var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 18.75V16.25C13.5 12.7982 16.2982 10 19.75 10C23.2018 10 26 12.7982 26 16.25V18.75C27.3807 18.75 28.5 19.8693 28.5 21.25L28.5 27.5C28.5 28.8807 27.3807 30 26 30L13.5 30C12.1193 30 11 28.8807 11 27.5V21.25C11 19.8693 12.1193 18.75 13.5 18.75ZM23.5 16.25V18.75H16V16.25C16 14.1789 17.6789 12.5 19.75 12.5C21.8211 12.5 23.5 14.1789 23.5 16.25Z",
    fill: "#9756DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleLock);
export default __webpack_public_path__ + "static/media/circle-lock.1a2fea8a73d539c8d0c350ae7b10e9b6.svg";
export { ForwardRef as ReactComponent };